import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var PaywallModal = require("components/users/teachers/PaywallModal");
var UIActions = require("lib/actions/UIActions");
var Features = require("lib/account/Features")

@connect(
	(state, props) => {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {}
		var admin = RosterSelectors.admin({state, id: CurrentUser.get().id})
		
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}
		var hasLogReading = Features.isEnabled(Features.LOG_READING);
		return {
			prefs,
			hasLogReading
		}
	},

	(dispatch, props) => ({
		populateData: () => {
            //STEP 1: Grab logged in admin
            return Promise.all([ dispatch(RosterActions.fetchAdmins({
                filters:{ids: [CurrentUser.get().id]}, 
                embeds:['user.prefs'],
                cache: true
            }))])
        },
        showLogReadingPaywall: () =>
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.LOG_READING })),
		onChange: (prefsUpdate, message) => {
			
			// RESETING ALL STUDENT LISTS
			var resetStudentLists = false

			if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.") == true) {
				resetStudentLists = true
			} 

			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", text: message, icon: "ok-sign"
			});

			return dispatch( RosterActions.updateAdminPrefs({
				id: CurrentUser.get().id,
				resetStudentLists: resetStudentLists,
				update: prefsUpdate
			}))
		},

	})
)

@providePopulateData({waitForLoad:true})
class PromptLogReadingPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onPromptLogReadingChange(value) {
		if (!this.props.hasLogReading) {
			this.props.showLogReadingPaywall()
		} else {
			var prefsHash = { prompt_log_reading: value }
			this.props.onChange(prefsHash, "You successfully changed the log reading prompt setting.");	
		}
	}

	render() {
		return (
			<div>
				<p> Automatically prompt your students to log reading after completing their writing.</p>
				<div className="viewableScoreOptions">
					<label>
						<input type="radio" onChange={ this.onPromptLogReadingChange.bind(this, true) }
							checked={ this.props.prefs.prompt_log_reading == true } />
						Ask my students to log reading 
					</label><br />
					<label>
						<input type="radio" onChange={ this.onPromptLogReadingChange.bind(this, false) }
							checked={ this.props.prefs.prompt_log_reading == false } />
						Do not ask my students to log reading
					</label>
				</div>	
			</div>
		)
	}
}

PromptLogReadingPreference.WrappedComponent.propTypes = StrictPropTypes({
	prefs: PropTypes.object,
	// Handlers from @connect
	hasLogReading: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	showLogReadingPaywall: PropTypes.func,
	populateData: PropTypes.func.isRequired
});

module.exports = PromptLogReadingPreference;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/PromptLogReadingPreference.js